(() => {
  const alternateLinks = window.swinger.$('link[rel="alternate"][hreflang]');
  const alternateHosts = alternateLinks.map((elem) => {
    const href = elem.href;
    const url = new URL(href);

    return `${url.protocol}//${url.host}`;
  });

  window.swinger.eventHub.register('click', '[href^="http"][target="_blank"]', (e) => {
    const elem = window.swinger.eventHub.getTarget(e).closest('a');
    const href = elem.getAttribute('href');
    const url = new URL(href);

    if (alternateHosts.indexOf(`${url.protocol}//${url.host}`) > -1) {
      elem.target = '_self';
    }
  });

  window.swinger.eventHub.register('click', '[href^="/go/"]', (e) => {
    const elem = window.swinger.eventHub.getTarget(e).closest('a');

    elem.target = '_blank';
  });

  // RSS/Atom Podcast Feeds
  // https://github.com/nathangathright/podcast-platform-links/blob/main/schemes.md
  const customProtocols = {
    'antennapod-subscribe://': 'uri', // AntennaPod
    'castros://subscribe/': 'uri', // Castro
    'downcast://': 'uri', // Downcast
    'gpodder://': 'uri', // gPodder
    'icatcher://': 'uri', // iCatcher!
    'instacast://': 'uri', // Instacast
    'overcast://x-callback-url/add?url=': 'uriComponent', // Overcast
    'playerfm://': 'uri', // Player FM
    'pktc://subscribe/': 'uri', // Pocket Casts
    'podcastaddict://': 'uri', // Podcast Addict
    'podcastguru://': 'uri', // Podcast Guru
    'podcat://': 'uri', // Podcat
    'podkicker://subscribe/': 'uri', // Podkicker
    'rssradio://': 'uri', // RSSRadio
    'podcast://': 'uri', // Apple Podcasts
  };

  const customProtocolCheck = (url) => {
    window.swinger.resourceLoader.script(`${window.swinger.config.assetsBase}/custom-protocol-check/custom-protocol-check.min.js?v=${window.swinger.config.version}`, () => {
      window.setTimeout(() => {
        window.swinger.eventHub.trigger(document, 'swinger-loading-indicator:hide');
      }, 2000);

      const notifyTimer = window.setTimeout(() => {
        window.swinger.clipboard.notify(url);
      }, 2000);

      const promises = Object.keys(customProtocols)
        .filter((customProtocol) => customProtocol !== 'podcast://')
        .map((customProtocol) => {
          const customProtocolURL = `${customProtocol}${customProtocols[customProtocol] === 'uriComponent' ? encodeURIComponent(url.replace('https://', '')) : url.replace('https://', '')}`;

          return new Promise((resolve) => {
            try {
              window.customProtocolCheck(customProtocolURL, () => {
                console.log(`"${customProtocolURL}" did not resolve`);
                resolve(false);
              }, () => {
                console.log(`"${customProtocolURL}" did resolve`);
                window.clearTimeout(notifyTimer);
                resolve(true);
              });
            } catch (e) {
              console.log(`"${customProtocolURL}" did not resolve`);
              resolve(false);
            }
          });
        });

      Promise.all(promises)
        .then((results) => {
          if (!results.filter((result) => result).length) {
            const customProtocol = 'podcast://';
            const customProtocolURL = `${customProtocol}${customProtocols[customProtocol] === 'uriComponent' ? encodeURIComponent(url.replace('https://', '')) : url.replace('https://', '')}`;

            window.customProtocolCheck(customProtocolURL, () => {
              console.log(`"${customProtocolURL}" also did not resolve`);
            }, () => {
              console.log(`"${customProtocolURL}" did resolve`);
              window.clearTimeout(notifyTimer);
            });
          }
        })
        .catch(console.info);
    });
  };

  window.swinger.eventHub.register('click', 'a[href*="/feed/"][href*="/atom"],a[href*="/feed/"][href*="/rss"]', (e) => {
    const elem = window.swinger.eventHub.getTarget(e).closest('a');
    const href = elem.href;

    if (elem.hasAttribute('data-authentication-required') && !window.swinger.user.isLoggedIn()) {
      return;
    }

    customProtocolCheck(href);
    window.swinger.clipboard.copy(href, false);

    window.swinger.eventHub.trigger(document, 'swinger-loading-indicator:show');

    e.preventDefault();
  });

  window.swinger.observer.initialize('a[href$="/feed/atom"],a[href$="/feed/rss"]', (elem) => {
    const buttonCopy = document.createElement('button');
    buttonCopy.className = 'swinger-button-copy-inline';
    buttonCopy.innerHTML = '<svg><use xlink:href="#swinger-svg-spritesheet-copy"></use></svg>';
    buttonCopy.setAttribute('data-authentication-required', '');
    buttonCopy.setAttribute('data-tooltip', '');
    buttonCopy.setAttribute('data-copy', elem.href);

    window.swinger.i18n()
      .then((i18n) => {
        buttonCopy.setAttribute('aria-label', i18n('ui.shared.copy'));
      })
      .catch(console.info);

    elem.insertAdjacentElement('afterend', buttonCopy);

    const update = (elem) => {
      window.swinger.api.getFeedUrls()
        .then((personalizedUrls) => {
          switch (true) {
            default:
            case Object.keys(personalizedUrls).length === 0:
              elem.setAttribute('href', elem.getAttribute('data-unauthorized-href'));
              elem.textContent = elem.getAttribute('data-unauthorized-href');
              buttonCopy.setAttribute('data-copy', elem.getAttribute('data-unauthorized-href'));
              break;

            case elem.href.indexOf('/atom') > -1 && !!personalizedUrls.atomurl:
              elem.href = personalizedUrls.atomurl;
              elem.textContent = personalizedUrls.atomurl;
              buttonCopy.setAttribute('data-copy', personalizedUrls.atomurl);
              break;

            case elem.href.indexOf('/rss') > -1 && !!personalizedUrls.rssurl:
              elem.href = personalizedUrls.rssurl;
              elem.textContent = personalizedUrls.rssurl;
              buttonCopy.setAttribute('data-copy', personalizedUrls.rssurl);
              break;
          }
        })
        .catch(() => {
          elem.setAttribute('href', elem.getAttribute('data-unauthorized-href'));
          elem.textContent = elem.getAttribute('data-unauthorized-href');
          buttonCopy.setAttribute('data-copy', elem.getAttribute('data-unauthorized-href'));
        });
    };

    elem.setAttribute('data-authentication-required', '');
    elem.setAttribute('data-unauthorized-href', elem.getAttribute('href'));
    window.swinger.observer.register('[data-authentication-required]', elem);

    document.addEventListener('swinger.user:authchange', () => {
      update(elem);
    });

    update(elem);
  }, false);
})();
